import React from 'react'

function B4() {
    return (
        <div>
            <h1>Great!</h1>
        </div>
    )
}

export default B4